import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";

export const CTA = () => {
  const { t } = useTranslation();
  
  return (
    <section className="relative px-4 py-24 sm:px-6">
      <div className="container mx-auto max-w-4xl">
        <div className="relative">
          <div className="absolute inset-0 bg-gradient-primary rounded-3xl blur-3xl opacity-20 animate-float" />
          <div className="relative bg-card border border-border rounded-3xl p-6 shadow-glow animate-scale-in sm:p-12">
            <div className="text-center space-y-6">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20">
                <Sparkles className="w-4 h-4 text-primary" />
                <span className="text-sm text-primary font-medium">
                  {t('cta.startYourJourney')}
                </span>
              </div>

              <h2 className="text-4xl md:text-5xl font-bold text-foreground">
                {t('cta.readyToUnlock')}
                <br />
                <span className="text-gradient">{t('cta.fullPotential')}</span>
              </h2>

              <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
                {t('cta.description')}
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-6">
                <Button
                  size="lg"
                  className="group bg-primary hover:bg-primary/90 text-primary-foreground shadow-glow transition-all duration-300 hover:scale-105"
                >
                  {t('cta.getStartedFree')}
                  <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
                </Button>
                <Button
                  size="lg"
                  variant="outline"
                  className="border-border hover:bg-card/50 transition-all duration-300"
                >
                  {t('cta.scheduleDemo')}
                </Button>
              </div>

              <div className="pt-8 flex items-center justify-center gap-8 text-sm text-muted-foreground">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-accent" />
                  <span>{t('cta.noCreditCard')}</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-secondary" />
                  <span>{t('cta.setupInMinutes')}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
